import { cn } from '@/lib/utils';

interface NumPadProps {
  onDigit: (d: string) => void;
  onBackspace: () => void;
  onClear: () => void;
  className?: string;
}

const KEYS = [
  '7', '8', '9',
  '4', '5', '6',
  '1', '2', '3',
  '.', '0', 'DEL',
];

export function NumPad({ onDigit, onBackspace, onClear, className }: NumPadProps) {
  const handleKey = (key: string) => {
    if (key === 'DEL') {
      onBackspace();
    } else {
      onDigit(key);
    }
  };

  return (
    <div className={cn('grid grid-cols-3 gap-3', className)}>
      {KEYS.map((key) => (
        <button
          key={key}
          onPointerDown={(e) => {
            e.preventDefault();
            handleKey(key);
          }}
          className={cn(
            'flex items-center justify-center rounded-2xl text-2xl font-semibold select-none',
            'h-16 transition-all duration-75 active:scale-95',
            key === 'DEL'
              ? 'bg-red-500/15 text-red-500 dark:bg-red-500/20 dark:text-red-400 text-lg'
              : 'bg-white dark:bg-zinc-800 text-zinc-800 dark:text-zinc-100 shadow-sm border border-zinc-100 dark:border-zinc-700',
            'hover:brightness-95 active:brightness-90'
          )}
          aria-label={key === 'DEL' ? 'Backspace' : key}
        >
          {key === 'DEL' ? '⌫' : key}
        </button>
      ))}
      {/* Clear button spans full width */}
      <button
        onPointerDown={(e) => {
          e.preventDefault();
          onClear();
        }}
        className="col-span-3 flex items-center justify-center rounded-2xl h-12 text-sm font-medium text-zinc-500 dark:text-zinc-400 bg-zinc-100 dark:bg-zinc-800/60 border border-zinc-200 dark:border-zinc-700 active:scale-95 transition-all duration-75 select-none"
        aria-label="Clear"
      >
        Clear
      </button>
    </div>
  );
}
